import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Dropdown, DropdownButton } from "react-bootstrap";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import { Image } from "primereact/image";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { FilterMatchMode } from "primereact/api";
import { useTranslation } from "react-i18next";
import { FloatLabel } from "primereact/floatlabel";
import modal_logo from "../../../../_assets/img/sema-logo.png";
import modal_logo_min from "../../../../_assets/img/modal_logo_min.png";
import "./download.css";
import axios from "axios";

const DownloadDadosModal = ({ active, close, modalSize = "xl", title }) => {
  const { t } = useTranslation();
  const toast = useRef(null);

  const [show, setShow] = useState(false);
  const [layers, setLayers] = useState([]);
  const [metadados, setMetadados] = useState([]);

  const [filtersLayers, setFiltersLayers] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS }
  });
  const [globalFilterLayers, setGlobalFilterLayers] = useState("");

  const [globalFilterMeta, setGlobalFilterMeta] = useState("");
  const [arquivoConteudo, setArquivoConteudo] = useState("");
  const [showArquivoModal, setShowArquivoModal] = useState(false);


  const clientWidth = document.documentElement.clientWidth;

  useEffect(() => setShow(active), [active]);

  const handleClose = () => {
    setShow(false);
    close && close();
  };


  useEffect(() => {
    const fetchCapabilities = async () => {
      try {
        const response = await axios.get(
          'https://pedea.sema.ce.gov.br/geoserver/zcm/wms?service=WMS&version=1.3.0&request=GetCapabilities',
          { headers: { 'Content-Type': 'application/xml' } }
        )
        const xml = response.data
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(xml, 'text/xml')
        const layerElements = xmlDoc.querySelectorAll('Layer > Layer')
        const parsedLayers = []

        layerElements.forEach(layer => {
          const name = layer.querySelector('Name')?.textContent
          const title = layer.querySelector('Title')?.textContent

          let bbox = null
          let crs = 'EPSG:4326'

          const bboxEl = layer.querySelector('EX_GeographicBoundingBox')
          if (bboxEl) {
            const west = bboxEl.querySelector('westBoundLongitude')?.textContent
            const east = bboxEl.querySelector('eastBoundLongitude')?.textContent
            const south =
              bboxEl.querySelector('southBoundLatitude')?.textContent
            const north =
              bboxEl.querySelector('northBoundLatitude')?.textContent
            if (west && east && south && north) {
              bbox = `${south},${west},${north},${east}`
            }
          } else {
            const altBboxEl = layer.querySelector('BoundingBox')
            if (altBboxEl) {
              crs = altBboxEl.getAttribute('CRS') || 'EPSG:4326'
              const minx = altBboxEl.getAttribute('minx')
              const miny = altBboxEl.getAttribute('miny')
              const maxx = altBboxEl.getAttribute('maxx')
              const maxy = altBboxEl.getAttribute('maxy')
              if (minx && miny && maxx && maxy) {
                bbox = `${minx},${miny},${maxx},${maxy}`
              }
            }
          }

          let preview = null
          if (bbox && name) {
            preview = `https://pedea.sema.ce.gov.br/geoserver/zcm/wms?service=WMS&version=1.3.0&request=GetMap&layers=zcm:${name}&styles=&bbox=${bbox}&width=400&height=250&crs=${crs}&format=image/png&transparent=true`
          }

          if (name && title) {
            parsedLayers.push({
              id: name,
              name,
              title,
              preview
            })
          }
        })

        setLayers(parsedLayers)
      } catch (error) {
        console.error('Erro ao buscar GetCapabilities:', error)
      }
    }

    fetchCapabilities()
  }, [])

  const downloadGeoserver = (name, format) => {
    const url = `https://pedea.sema.ce.gov.br/geoserver/zcm/ows?service=WFS&version=1.1.0&request=GetFeature&typeName=zcm:${name}&outputFormat=${format}&srsName=EPSG:4674`;
    window.open(url, "_blank");
  };

  const onGlobalFilterLayersChange = e => {
    const value = e.target.value;
    let _filters = { ...filtersLayers };
    _filters.global.value = value;

    setFiltersLayers(_filters);
    setGlobalFilterLayers(value);
  };

  const headerLayers = (
    <div className="flex justify-content-between align-items-center w-full" style={{ marginTop: '10px' }} >
      <FloatLabel className="w-full">
        <IconField iconPosition="right" className="w-full">
          <InputIcon className="pi pi-search" />
          <InputText
            id="searchLayers"
            value={globalFilterLayers}
            onChange={onGlobalFilterLayersChange}
            className="w-full inputSearchLayer"
          />
        </IconField>
        <label htmlFor="searchLayers">Buscar camada</label>
      </FloatLabel>

    </div>

  );

  const headerMetadados = (
    <div className="flex justify-content-between align-items-center w-full" style={{ marginTop: '10px' }} >
      <FloatLabel className="w-full">
        <IconField iconPosition="right" className="w-full">
          <InputIcon className="pi pi-search" />
          <InputText
            id="searchMetadados"
            value={globalFilterMeta}
            onChange={e => setGlobalFilterMeta(e.target.value)}
            className="w-full inputSearchLayer"
          />
        </IconField>
        <label htmlFor="searchMetadados">Buscar metadado</label>
      </FloatLabel>

    </div>

  );

  const imageBodyTemplate = rowData => {

    return (
      <Image
        src={rowData.preview}
        alt={`Preview de ${rowData.name}`}
        className="img-geoserver"
        width="100%"
        preview={true}
        style={{
          borderRadius: '10px',
          objectFit: 'contain',
          maxHeight: '55vh'
        }}
      />
    )
  }


  useEffect(() => {
    const fetchMetadados = async () => {
      try {
        const response = await fetch(
          "https://pedea.sema.ce.gov.br/gestor-api/allmetadados"
        );
        if (!response.ok) throw new Error();
        const data = await response.json();
        setMetadados(data);
      } catch {
        toast.current?.show({
          severity: "error",
          summary: "Erro",
          detail: "Erro ao carregar metadados",
          life: 4000
        });
      }
    };

    fetchMetadados();
  }, []);

  const openArquivo = async name => {
    try {
      const response = await fetch(
        `https://pedea.sema.ce.gov.br/gestor-api/arquivotxt/${name}`
      );
      if (!response.ok) throw new Error();
      const text = await response.text();
      setArquivoConteudo(text);
      setShowArquivoModal(true);
    } catch {
      toast.current?.show({
        severity: "warn",
        summary: "Aviso",
        detail: "Erro ao abrir arquivo",
        life: 4000
      });
    }
  };

  const downloadArquivo = async name => {
    try {
      const response = await fetch(
        `https://pedea.sema.ce.gov.br/gestor-api/downloadMetadado/${name}`
      );
      if (!response.ok) throw new Error();

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `${name}.txt`;
      link.click();
    } catch {
      toast.current?.show({
        severity: "error",
        summary: "Erro",
        detail: "Erro ao baixar arquivo",
        life: 4000
      });
    }
  };

  return (
    <>
      <Toast ref={toast} />

      <Modal show={show} onHide={handleClose} size={modalSize} id="ModalGeoserver">
        <Modal.Header>

          {/*   <div className="ContainerLogo">
            <img
              className="img-thumbnail"
              alt="Logo"
              title="Logo"
              src={clientWidth > 350 ? modal_logo : modal_logo_min}
            />
          </div> */}
        </Modal.Header>

        <Modal.Body className="containerTableGeoserver">
          <p className="TitleDownload">
            Escolha abaixo os dados do GeoServer PEDEA ou acesse as informações e metadados das camadas disponíveis na PEDEA.
          </p>


          <TabView>

            <TabPanel header={t("downloadDados.tabs.geoserver")}>

              <DataTable
                value={layers}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 25, 50]}
                stripedRows
                showGridlines
                dataKey="id"
                filters={filtersLayers}
                globalFilterFields={["title", "name"]}
                header={headerLayers}
                emptyMessage="Nenhuma camada encontrada."
                style={{ fontWeight: 'bold', fontFamily: 'Kanit' }}

              >
                <Column header="Imagem da camada" body={imageBodyTemplate} />
                <Column
                  header="Título"
                  body={row => <Tag value={row.title} className="Tags" rounded />}
                />
                <Column
                  header="Nome"
                  body={row => <Tag value={row.name} className="Tags" rounded />}
                />
                <Column
                  header="Baixar"
                  body={row => (
                    <DropdownButton
                      title="Baixar"
                      size="sm"
                      className="DropdownGeoserver"
                    >
                      <Dropdown.Item onClick={() => downloadGeoserver(row.name, "shape-zip")}>
                        Shapefile (ZIP)
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => downloadGeoserver(row.name, "kml")}>
                        KML
                      </Dropdown.Item>
                    </DropdownButton>
                  )}
                />
              </DataTable>
            </TabPanel>


            <TabPanel header={t("downloadDados.tabs.metadados")}>


              <DataTable
                value={metadados.filter(m => m.id_camada)}
                globalFilter={globalFilterMeta}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 25, 50]}
                stripedRows
                showGridlines
                header={headerMetadados}
                style={{ fontWeight: 'bold', fontFamily: 'Kanit' }}
              >
                <Column field="camada.categoria_de_informacao" header="Categoria" />
                <Column field="camada.nomenclatura_pedea" header="Nome (Titulo Geoserver)" />
                <Column
                  header="Visualizar"
                  body={row => (
                    <i
                      className="pi pi-file"
                      style={{ cursor: "pointer" }}
                      onClick={() => openArquivo(row.name)}

                    />
                  )}
                />
                <Column
                  header="Baixar arquivo"
                  body={row => (
                    <i
                      className="pi pi-download"
                      style={{ cursor: "pointer" }}
                      onClick={() => downloadArquivo(row.name)}
                    />
                  )}
                />
              </DataTable>
            </TabPanel>

          </TabView>
        </Modal.Body>

        <Modal.Footer>
          <Button
            label={t("common.close")}
            icon="pi pi-times"
            severity="secondary"
            raised
            onClick={handleClose}
            style={{ borderRadius: '10px' }}
          />
        </Modal.Footer>
      </Modal>

      <Dialog
        header="Conteúdo do Arquivo"
        visible={showArquivoModal}
        onHide={() => setShowArquivoModal(false)}
        style={{ width: "60vw", borderRadius: '10px' }}
        modal
      >
        <pre style={{ whiteSpace: "pre-wrap" }}>{arquivoConteudo}</pre>
      </Dialog>
    </>
  );
};

DownloadDadosModal.propTypes = {
  active: PropTypes.bool,
  close: PropTypes.func,
  modalSize: PropTypes.string,
  title: PropTypes.string
};

export default DownloadDadosModal;
